import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { surveyQueryKeys, updateSurvey } from '../api/surveys.api';
import type { UpdateSurveyPayload } from '../types/survey.types';

export function useUpdateSurvey(surveyId: number, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateSurveyPayload) => updateSurvey(surveyId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: surveyQueryKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: surveyQueryKeys.detail(surveyId) });
      toast.success('Survey updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update survey');
    },
  });
}
